import { z } from 'zod'

import { BrevoProposalKindType, BrevoProposalStatus } from '@gto/api-client/admin/react-query'

export const ALL_RUNS = 'all'

export const InsightsSearchSchema = z.object({
  status: z.array(z.enum(BrevoProposalStatus)).optional().catch([]),
  kind: z.array(z.enum(BrevoProposalKindType)).optional().catch([]),
  run: z
    .union([z.literal(ALL_RUNS), z.uuid()])
    .optional()
    .catch(undefined),
})
export type InsightsSearch = z.infer<typeof InsightsSearchSchema>
